import React from 'react';
import { Link } from 'react-router-dom';
import { BadgeCheck, CheckCircle2, CreditCard, MessageCircle, Package, Plane, ShieldCheck, Truck } from 'lucide-react';
import { Button } from 'components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from 'components/ui/card';
import { Logo } from 'components/Logo';
import { useLanguage } from 'lib/i18n';
import { LanguageSwitcher } from 'components/LanguageSwitcher';

const steps = [
  { icon: Package, title: 'how.step1Title', text: 'how.step1Text' },
  { icon: Plane, title: 'how.step2Title', text: 'how.step2Text' },
  { icon: MessageCircle, title: 'how.step3Title', text: 'how.step3Text' },
  { icon: CreditCard, title: 'how.step4Title', text: 'how.step4Text' },
  { icon: Truck, title: 'how.step5Title', text: 'how.step5Text' },
  { icon: CheckCircle2, title: 'how.step6Title', text: 'how.step6Text' },
];

export default function HowItWorksPage() {
  const { t } = useLanguage();
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b bg-card/90">
        <div className="mx-auto flex h-16 items-center justify-between gap-2 px-4 sm:px-6">
          <Link to="/" className="shrink-0"><Logo size="sm" hideTextOnMobile /></Link>
          <div className="flex items-center gap-1 sm:gap-2"><LanguageSwitcher /><Link to="/login"><Button className="px-2 text-xs sm:px-4 sm:text-sm" variant="ghost">{t('auth.login')}</Button></Link><Link to="/register"><Button className="px-2 text-xs sm:px-4 sm:text-sm">{t('auth.createAccount')}</Button></Link></div>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-4 py-12 sm:px-6 sm:py-16">
        <div className="max-w-2xl">
          <p className="mb-3 text-sm font-semibold uppercase tracking-wide text-primary">{t('how.eyebrow')}</p>
          <h1 className="text-4xl font-bold tracking-tight sm:text-5xl">{t('how.title')}</h1>
          <p className="mt-4 text-lg text-muted-foreground">{t('how.intro')}</p>
        </div>
        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {steps.map(({ icon: Icon, title, text }, index) => (
            <Card key={title} className="h-full">
              <CardHeader><div className="flex items-center gap-3"><span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary/10 text-primary">{index + 1}</span><Icon size={20} className="text-primary" /><CardTitle className="text-base">{t(title)}</CardTitle></div></CardHeader>
              <CardContent className="pt-0 text-sm text-muted-foreground">{t(text)}</CardContent>
            </Card>
          ))}
        </div>
        <section className="mt-12 grid gap-4 rounded-lg border bg-card p-6 sm:grid-cols-3">
          <Trust icon={BadgeCheck} title={t('how.identity')} text={t('how.identityText')} />
          <Trust icon={ShieldCheck} title={t('how.protection')} text={t('how.protectionText')} />
          <Trust icon={MessageCircle} title={t('how.communication')} text={t('how.communicationText')} />
        </section>
      </main>
    </div>
  );
}

function Trust({ icon: Icon, title, text }) {
  return <div className="flex gap-3"><Icon className="mt-0.5 shrink-0 text-emerald-600" size={20} /><div><h2 className="font-semibold">{title}</h2><p className="mt-1 text-sm text-muted-foreground">{text}</p></div></div>;
}
